<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

<div
  class="w-full flex flex-col flex-grow bg-white border border-solid border-detail-list-border overflow-y-auto"
  >
  @for (newsItem of news; track newsItem; let i = $index) {
    <div
      class="border-b border-solid border-detail-list-border hover:bg-gray-neutral-200"
      [class.bg-notification-read-bg]="newsItem.isReaded && !(selectedNews && selectedNews.id === newsItem.id)"
      [class.bg-selected-item]="selectedNews && selectedNews.id === newsItem.id"
      >
      <div class="flex justify-between items-center">
        <button (click)="onNewsClick(newsItem)" class="flex flex-col px-2 md:px-4 py-6 w-full">
          <p class="body-2 text-gray">{{ newsItem.date | date: 'shortDate' }}</p>
          <div class="!my-1 text-left mat-subtitle-2" [ngClass]="{ '!font-bold': !newsItem.isReaded }">
            {{ newsItem.title }}
          </div>
          <aup-news-chip [news]="newsItem"></aup-news-chip>
        </button>
        @if (isMobile) {
          <button mat-icon-button (click)="openMenu(i)">
            <mat-icon color="primary" fontIcon="more_horiz"></mat-icon>
          </button>
        }
      </div>
      <ng-template #actionsMenu>
        <mat-nav-list>
          @if (!newsItem.isReaded) {
            <button mat-list-item (click)="onChangeRead(newsItem, true)">
              {{ 'NEWS.ACTIONS.MARK_AS_READ' | transloco }}
            </button>
          }
          @if (newsItem.isReaded) {
            <button mat-list-item (click)="onChangeRead(newsItem, false)">
              {{ 'NEWS.ACTIONS.MARK_AS_UNREAD' | transloco }}
            </button>
          }
        </mat-nav-list>
      </ng-template>
    </div>
  }
</div>
